module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.hasDarkTheme ? 'darkMode' : ''],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('top-navbar'), _vm._v(" "), (_vm.isSignup) ? _c('notifications', {
    staticClass: "ssu-alert-container"
  }) : _vm._e(), _vm._v(" "), (_vm.isSignup) ? _c('signup', {
    staticClass: "signup"
  }) : _vm._e(), _vm._v(" "), (_vm.subNavbarVisible) ? _c('bottom-navbar') : _vm._e(), _vm._v(" "), (!_vm.isSignup) ? _c('div', {
    staticClass: "container app",
    class: _vm.visibilityClass
  }, [_c('notifications'), _vm._v(" "), _c('notices'), _vm._v(" "), _c('refresh-password-modal'), _vm._v(" "), _c('router-view')], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isSignup) ? _c('foot') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16940fba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1308
// module chunks = 16